import Route from '@ember/routing/route';
import backlinkViewRouteMixin from 'nightwatch-web/mixins/backlink-view-route';

export default class DashboardUrlBacklinkViewNewRoute extends Route.extend(
  backlinkViewRouteMixin
) {}
